import { restRequest } from '../rest/rest';
export class ConsentService {
    constructor(config) {
        this.consentEndpoint = '/digital/v3/chat/api/user/consent';
        this.config_ = config;
    }
    async getConsent(token, consentType) {
        if (this.config_.useMocks.getConsent) {
            return Promise.resolve({
                consentType: consentType !== null && consentType !== void 0 ? consentType : 'TERMS_OF_USE',
                consentContent: 'TBD',
                consentAccepted: false,
                versionId: '1.0',
            });
        }
        try {
            const consent = (await restRequest(`${this.config_.environment}${this.consentEndpoint}`, 'GET', undefined, token, [
                {
                    name: 'consentType',
                    value: consentType !== null && consentType !== void 0 ? consentType : 'TERMS_OF_USE',
                },
            ]));
            return consent;
        }
        catch (e) {
            const chatError = e;
            if (chatError && chatError.code) {
                throw chatError;
            }
            else {
                throw { code: 'METHOD_ERROR', message: 'Invalid response.' };
            }
        }
    }
    async setConsent(token, consentInfo) {
        if (this.config_.useMocks.setConsent) {
            return Promise.resolve();
        }
        try {
            const response = (await restRequest(`${this.config_.environment}${this.consentEndpoint}`, 'POST', consentInfo, token));
            if (!response) {
                throw Error();
            }
            return Promise.resolve();
        }
        catch (e) {
            const chatError = e;
            if (chatError && chatError.code) {
                throw chatError;
            }
            else {
                throw { code: 'METHOD_ERROR', message: 'Invalid response.' };
            }
        }
    }
}
//# sourceMappingURL=consent-service.js.map